document.addEventListener('toggle',e=>{if(e.target.matches('.gastro-department')&&e.target.open)document.querySelectorAll('.gastro-department[open]').forEach(d=>{if(d!==e.target)d.open=false})},true);document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.gastro-department[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});document.addEventListener('click',e=>{if(!e.target.closest('.gastro-navigation'))document.querySelectorAll('.gastro-department[open]').forEach(d=>d.open=false)});
document.addEventListener('click',e=>{if(!e.target.closest('.gastro-language'))document.querySelectorAll('.gastro-language[open]').forEach(d=>d.open=false)});document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.gastro-language[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})});
let gastroHoverClose;
document.querySelectorAll('.gastro-department').forEach(department=>{
  department.addEventListener('pointerenter',event=>{
    if(event.pointerType!=='mouse')return;
    clearTimeout(gastroHoverClose);
    document.querySelectorAll('.gastro-department[open]').forEach(other=>{if(other!==department)other.open=false});
    department.open=true;
  });
  department.addEventListener('pointerleave',event=>{
    if(event.pointerType!=='mouse')return;
    gastroHoverClose=setTimeout(()=>{department.open=false},180);
  });
});
/* Picture-led two-column category navigation. Links remain usable without JS. */
document.querySelectorAll('.gastro-mega').forEach(menu=>{
  const list=menu.querySelector(':scope > ul');if(!list)return;
  menu.classList.add('gastro-picture-menu');
  const panels=document.createElement('div');panels.className='gastro-menu-panels';
  menu.append(panels);
  const items=[...list.children];
  let hoverTimer;
  const cancelHover=()=>clearTimeout(hoverTimer);
  menu.addEventListener('pointerleave',cancelHover);
  panels.addEventListener('pointerenter',cancelHover);
  function activate(item){items.forEach(row=>{const active=row===item;row.classList.toggle('is-active',active);const link=row.querySelector(':scope > a');link.setAttribute('aria-expanded',String(active));const panel=panels.querySelector('#'+link.getAttribute('aria-controls'));if(panel)panel.hidden=!active})}
  items.forEach((item,index)=>{
    const link=item.querySelector(':scope > a');if(!link)return;
    const panel=document.createElement('section');panel.className='gastro-menu-panel';panel.id='menu-panel-'+link.getAttribute('href').split('hendi-').pop().replace(/[^0-9]/g,'');
    link.setAttribute('aria-controls',panel.id);
    const children=item.querySelector(':scope > ul');
    if(children)panel.append(children);else{const all=link.cloneNode(true);all.querySelector('img')?.remove();panel.append(all)}
    panels.append(panel);
    item.addEventListener('pointerenter',event=>{
      if(event.pointerType!=='mouse')return;
      cancelHover();
      hoverTimer=setTimeout(()=>activate(item),120);
    });
    item.addEventListener('pointerleave',cancelHover);
    link.addEventListener('focus',()=>{cancelHover();activate(item)});
    link.addEventListener('click',event=>{if(!matchMedia('(hover:hover)').matches&&!item.classList.contains('is-active')){event.preventDefault();activate(item)}});
    panel.hidden=index!==0;
  });
  if(items.length)activate(items[0]);
});

// The department label opens its collection; hover and keyboard arrows expose its submenu.
document.querySelectorAll('.gastro-department > summary').forEach(summary=>{
  summary.addEventListener('click',event=>{
    const department=summary.parentElement;
    const destination=department.querySelector('.gastro-view-department');
    if(!destination)return;
    event.preventDefault();
    department.open=false;
    location.href=destination.href;
  });
  summary.addEventListener('keydown',event=>{
    if(event.key==='ArrowDown'){
      event.preventDefault();
      summary.parentElement.open=true;
      summary.parentElement.querySelector('.gastro-picture-menu > ul > li > a')?.focus();
    }
  });
});
// Open language choices on mouse hover; retain click and keyboard support.
document.querySelectorAll('details.gastro-language').forEach(menu=>{
  menu.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')menu.open=true;});
  menu.addEventListener('pointerleave',event=>{if(event.pointerType==='mouse'&&!menu.contains(document.activeElement))menu.open=false;});
  menu.addEventListener('focusout',event=>{if(!menu.contains(event.relatedTarget)&&!menu.matches(':hover'))menu.open=false;});
  menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.querySelector('summary').focus();menu.open=false;}});
});
